import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "react-slick";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { map_data } from "../Intro.js";

const useStyles = makeStyles(styles);

export default function ProductSection(props) {
  const classes = useStyles();
  const [slideShow, setSlideShow] = React.useState(0);
  let slider_var;
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
  };
  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>जानकारी</small>
            <span>
              <h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}>
              {props.selected_data === 'bhaktapur_ddc' ? 'जिल्लास्तरका प्रशासनिक निकायहरु र तिनका कार्य क्षेत्रहरु' : 'नगरपालिका अन्तर्गतका शाखा कार्यालयहरु र सम्पर्क'}
              </h3>
            </span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <div style={{ margin: 'auto', textAlign: 'left' }}>
            {props.selected_data === 'bhaktapur_ddc' &&
            <GridContainer xs={12} sm={10} md={8} style={{ margin: 'auto' }}>
              <Card carousel>
                <GridContainer justify="center" style={{ margin: 'auto' }} xs={12} sm={12} md={12}>
                  <GridItem xs={12} sm={12} md={12}>
                    {['जिल्ला प्रशासन कार्यालय','जिल्ला समन्वय समिति','जिल्ला प्रहरी कार्यालय','जिल्ला खेलकुद कार्यालय','जिल्ला नापी कार्यालय'].map((title, i)=>
                      <Button onClick={()=>slider_var.slickGoTo(i)} color="transparent" style={slideShow === i ? {color: '#134c7a', border: '1px solid #134c7a', borderRadius: '100px', padding: '4px'} : {color: '#134c7a', padding: '5px'}} size="sm">
                      {title}
                      </Button>
                    )}
                  </GridItem>
                </GridContainer>
                <Carousel {...settings} beforeChange={(oldIndex, index) => {setSlideShow(index)}} ref={slider => (slider_var = slider)}>
                  <GridContainer style={{ backgroundColor: '#fff',  }}>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'left' }}>
                      <b>जिल्ला प्रशासन कार्यालय</b>
                      <br />
                      <p>जिल्लामा शान्ति सुव्यवस्था र सुरक्षा कायम गरी जनताको जिउ, धनको संरक्षण गर्ने,  जिल्लामा नेपाल सरकारको प्रतिनिधिको रुपमा रही सार्वजनिक सेवा वितरण (Public Service Delivery) लाई प्रभावकारी बनाई सुशासनको प्रत्याभूति गर्ने आदि।</p>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'right' }}>
                      <b>सम्पर्क:</b>
                      <div>
                        जिल्ला प्रशासन कार्यालय, भक्तपुर<br/>
                        भक्तपुर नगरपालिका-३‚ दरवार स्क्वायर<br/>
                        फोन नं.<br/>
                        १)  +९७७-०१-६६१४४३७ (प्र.जि.अ.)<br/>
                        २)  +९७७-०१-६६१५५९५ (स.प्र.जि.अ.)<br/>
                        ३)  +९७७-०१-६६१४६०७ (फ्याक्स)<br/>
                        मोवाईल न‌ंः ९७७-९८५१२१७७७७ (प्र.जि.अ. मोवाईल नं)<br/>
                        ईमेल: <a href="mailto:daobhaktapur@gmail.com" style={{ color: '#567' }}>daobhaktapur@gmail.com</a><br/>
                        वेबसाइट: <a href="http://daobhaktapur.moha.gov.np" style={{ color: '#567' }}>daobhaktapur.moha.gov.np</a><br/>
                        फेसबुक: <a href="https://www.facebook.com/daobhaktapur" style={{ color: '#567' }}>facebook.com/daobhaktapur</a><br/>
                        ट्वीटर: <a href="https://twitter.com/daobhaktapur" style={{ color: '#567' }}>twitter.com/daobhaktapur</a><br/>
                      </div>
                    </GridItem>
                  </GridContainer>
                  <GridContainer style={{ backgroundColor: '#fff' }}>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'left' }}>
                      <b>जिल्ला समन्वय समिति</b>
                      <br />
                      <p>जिल्ला समन्वय समिति कार्यालय निर्वाचित जनप्रतिनिधिहरुले नेतृत्व गर्ने कार्यालय हो । जिल्ला समन्वय समितिले नेपालको संविधानको धारा २२० अनुसारको कामहरु, प्रदेश कानून बमोजिमका कार्यहरु गर्ने र स्थानीय सरकार संचालन ऐन २०७४ बमोजिमका जिल्ला समन्वय समितिले गर्नुपर्ने कार्यहरु गर्दछ।</p>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'right' }}>
                      <b>सम्पर्क:</b>
                      <div>
                        जिल्ला समन्वय समिति<br/>
                        <br/>
                        फोन नं.<br/>
                        मोवाईल न‌ंः<br/>
                        ईमेल: <a href="mailto:daobhaktapur@gmail.com" style={{ color: '#567' }}>exapmle@gmail.com</a><br/>
                        वेबसाइट: <a href="http://daobhaktapur.moha.gov.np" style={{ color: '#567' }}>example.gov.np</a><br/>
                        फेसबुक: <a href="https://www.facebook.com/daobhaktapur" style={{ color: '#567' }}>facebook.com</a><br/>
                        ट्वीटर: <a href="https://twitter.com/daobhaktapur" style={{ color: '#567' }}>twitter.com</a><br/>
                      </div>
                    </GridItem>
                  </GridContainer>
                  <GridContainer style={{ backgroundColor: '#fff' }}>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'left' }}>
                      <b>जिल्ला प्रहरी कार्यालय</b>
                      <br />
                      <p>-</p>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'right' }}>
                      <b>सम्पर्क:</b>
                      <div>
                        जिल्ला समन्वय समिति<br/>
                        <br/>
                        फोन नं.<br/>
                        मोवाईल न‌ंः<br/>
                        ईमेल: <a href="mailto:daobhaktapur@gmail.com" style={{ color: '#567' }}>exapmle@gmail.com</a><br/>
                        वेबसाइट: <a href="http://daobhaktapur.moha.gov.np" style={{ color: '#567' }}>example.gov.np</a><br/>
                        फेसबुक: <a href="https://www.facebook.com/daobhaktapur" style={{ color: '#567' }}>facebook.com</a><br/>
                        ट्वीटर: <a href="https://twitter.com/daobhaktapur" style={{ color: '#567' }}>twitter.com</a><br/>
                      </div>
                    </GridItem>
                  </GridContainer>
                  <GridContainer style={{ backgroundColor: '#fff' }}>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'left' }}>
                      <b>जिल्ला खेलकुद कार्यालय</b>
                      <br />
                      <p>-</p>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'right' }}>
                      <b>सम्पर्क:</b>
                      <div>
                        जिल्ला समन्वय समिति<br/>
                        <br/>
                        फोन नं.<br/>
                        मोवाईल न‌ंः<br/>
                        ईमेल: <a href="mailto:daobhaktapur@gmail.com" style={{ color: '#567' }}>exapmle@gmail.com</a><br/>
                        वेबसाइट: <a href="http://daobhaktapur.moha.gov.np" style={{ color: '#567' }}>example.gov.np</a><br/>
                        फेसबुक: <a href="https://www.facebook.com/daobhaktapur" style={{ color: '#567' }}>facebook.com</a><br/>
                        ट्वीटर: <a href="https://twitter.com/daobhaktapur" style={{ color: '#567' }}>twitter.com</a><br/>
                      </div>
                    </GridItem>
                  </GridContainer>
                  <GridContainer style={{ backgroundColor: '#fff' }}>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'left' }}>
                      <b>जिल्ला नापी कार्यालय</b>
                      <br />
                      <p>-</p>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'right' }}>
                      <b>सम्पर्क:</b>
                      <div>
                        जिल्ला समन्वय समिति<br/>
                        <br/>
                        फोन नं.<br/>
                        मोवाईल न‌ंः<br/>
                        ईमेल: <a href="mailto:daobhaktapur@gmail.com" style={{ color: '#567' }}>exapmle@gmail.com</a><br/>
                        वेबसाइट: <a href="http://daobhaktapur.moha.gov.np" style={{ color: '#567' }}>example.gov.np</a><br/>
                        फेसबुक: <a href="https://www.facebook.com/daobhaktapur" style={{ color: '#567' }}>facebook.com</a><br/>
                        ट्वीटर: <a href="https://twitter.com/daobhaktapur" style={{ color: '#567' }}>twitter.com</a><br/>
                      </div>
                    </GridItem>
                  </GridContainer>
                </Carousel>
              </Card>
            </GridContainer>
            }
            {props.selected_data !== 'bhaktapur_ddc' &&
            <GridContainer xs={12} sm={10} md={8} style={{ margin: 'auto' }}>
              <Card carousel>
                <GridContainer justify="center" style={{ margin: 'auto' }} xs={12} sm={12} md={12}>
                  <GridItem xs={12} sm={12} md={12}>
                    {['प्रशासन शाखा','शिक्षा शाखा','आर्थिक शाखा','संस्कृति तथा पर्यटन शाखा','भौतिक योजना तथा निर्माण शाखा', 'समाज कल्याण शाखा', 'वाताबरण शाखा'].map((title, i)=>
                      <Button onClick={()=>slider_var.slickGoTo(i)} color="transparent" style={slideShow === i ? {color: '#134c7a', border: '1px solid #134c7a', borderRadius: '100px', padding: '4px'} : {color: '#134c7a', padding: '5px'}} size="sm">
                      {title}
                      </Button>
                    )}
                  </GridItem>
                </GridContainer>
                <Carousel {...settings} beforeChange={(oldIndex, index) => {setSlideShow(index)}} ref={slider => (slider_var = slider)}>
                  {['प्रशासन शाखा','शिक्षा शाखा','आर्थिक शाखा','संस्कृति तथा पर्यटन शाखा','भौतिक योजना तथा निर्माण शाखा', 'समाज कल्याण शाखा', 'वाताबरण शाखा'].map((title, i)=>
                  <GridContainer style={{ backgroundColor: '#fff',  }}>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'left' }}>
                      <b>{title}</b>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} style={{ padding: '30px', float: 'right' }}>
                      <b>सम्पर्क:</b>
                      <div>
                        {map_data[props.selected_data].description}<br/>
                        <br/>
                        फोन नं.<br/>
                        मोवाईल न‌ंः<br/>
                        ईमेल: <a href="mailto:daobhaktapur@gmail.com" style={{ color: '#567' }}>exapmle@gmail.com</a><br/>
                        वेबसाइट: <a href="http://daobhaktapur.moha.gov.np" style={{ color: '#567' }}>example.gov.np</a><br/>
                        फेसबुक: <a href="https://www.facebook.com/daobhaktapur" style={{ color: '#567' }}>facebook.com</a><br/>
                        ट्वीटर: <a href="https://twitter.com/daobhaktapur" style={{ color: '#567' }}>twitter.com</a><br/>
                      </div>
                    </GridItem>
                  </GridContainer>)}
                </Carousel>
              </Card>
            </GridContainer>
            }
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
